import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { FacetType } from "../components/GemelData/MiniGemelDataFacetsList";

import { FundDataBasic, FundDataYields, FundFacet, FundFileType } from "../interfaces/DTO/FundDataBasic";
import { queryKeys } from "../queries/queryKeys";
import { fundService } from "../services/fundService";
import { useEffect, useState } from "react";

const ONE_HOUR_IN_MILLISECONDS = 60 * 60 * 1000;


// Hook לשליפת פרטי מסלול השקעה לפי קוד מסלול
export const useInvestmentPathDetails = (pathCode: number) => {
  return useQuery<FundDataBasic[], Error>({
    queryKey: [queryKeys.fundsById, pathCode], // מפתח ייחודי עבור קוד מסלול
    queryFn: () => fundService.fetchFundById(pathCode), // הפונקציה שמביאה את הנתונים
    staleTime: ONE_HOUR_IN_MILLISECONDS, // הנתונים ייחשבו "טריים" למשך 100 שניות
    enabled: !!pathCode, // הפעלה רק אם יש pathCode
  });
};


export const useAllFundsQuery = () => {
  return useQuery<FundDataBasic[]>({
    queryKey: queryKeys.allFunds, // מפתח ייחודי לשאילתה
    queryFn: async () => {
      const [gemel, pensia, insurance] = await Promise.all([
        fundService.fetchFundsByFileTypeWithCache(FundFileType.GEMELNET),
        fundService.fetchFundsByFileTypeWithCache(FundFileType.PENSIANET),
        fundService.fetchFundsByFileTypeWithCache(FundFileType.INSURANCENET),
      ]);
      return [...gemel, ...pensia, ...insurance];
    },
    staleTime: 1000 * 60 * 60 * 12, // 12 שעות
    retry: 2,
    refetchOnWindowFocus: false,
  });
};

// export const useFundsByIds = (fundIds?: number[]) => {
//   return useQuery<FundDataBasic[], Error>({
//     queryKey: [queryKeys.fundsByIds, fundIds], // מפתח ייחודי לשאילתה
//     queryFn: async () => {
//       // בדיקה נוספת לפני קריאה לשירות
//       if (!fundIds || fundIds.length === 0) {
//         return [];
//       }
//       return fundService.fetchFundsByIds(fundIds);
//     },
//     enabled: Array.isArray(fundIds) && fundIds.length > 0, // הפעלה רק אם יש קודים במערך
//     staleTime: 60000, // הנתונים ייחשבו "טריים" למשך 60 שניות
//   });
// };


export const useFundsYieldsByIds = (fundIds: number[], monthsBack: number = 12) => {
  return useQuery<FundDataYields[], Error>({
    queryKey: [queryKeys.fundsYieldsByIds, fundIds, monthsBack], // מפתח ייחודי לשאילתה
    queryFn: () => fundService.fetchFundsYieldsByIds(fundIds, monthsBack), // הפונקציה שמביאה את הנתונים
    enabled: fundIds.length > 0, // הפעלה רק אם יש מזהים
    staleTime: ONE_HOUR_IN_MILLISECONDS, // הנתונים ייחשבו "טריים" למשך 10 דקות
  });
};

export const useTopFundsByCriteria = (
  filterField: FacetType,
  filterValue: string,
  reportPeriod: string,
  sortField: string,
  topN: number
) => {
  return useQuery<FundDataBasic[], Error>({
    queryKey: [
      "topFundsByCriteria",
      filterField,
      filterValue,
      reportPeriod,
      sortField,
      topN,
    ],
    queryFn: () =>
      fundService.fetchTopFundsByCriteria(
        filterField,
        filterValue,
        reportPeriod,
        sortField,
        topN
      ),
    staleTime: 24 * 60 * 60 * 1000,
    enabled: !!filterField && !!filterValue,
  });
};




